"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_NAMESPACE = exports.USER_LABEL = exports.TUserDetails = exports.TDeliveryAddress = exports.TFavoriteStore = exports.TCommunicationPreference = void 0;
const t = __importStar(require("io-ts"));
const country_code_1 = require("./country-code");
const gender_1 = require("./gender");
exports.TCommunicationPreference = t.interface({
    id: t.string,
    value: t.union([t.boolean, t.null, t.number, t.string]),
});
// TODO: Revisit real schema
exports.TFavoriteStore = t.any;
exports.TDeliveryAddress = t.intersection([
    t.interface({
        addressLine1: t.string,
        city: t.string,
        phoneNumber: t.string,
    }),
    t.partial({
        addressLine2: t.union([t.string, t.null]),
        // Nickname user gives to the delivery address e.g "home", "work"
        alias: t.union([t.string, t.null]),
        country: t.union([t.string, t.null]),
        latitude: t.union([t.number, t.null]),
        longitude: t.union([t.number, t.null]),
        route: t.union([t.string, t.null]),
        state: t.union([t.string, t.null]),
        streetNumber: t.union([t.string, t.null]),
        zip: t.union([t.string, t.null]),
    }),
]);
exports.TUserDetails = t.intersection([
    t.interface({
        email: t.string,
    }),
    t.partial({
        adsPersonalizationOptOut: t.union([t.boolean, t.null]),
        autoReloadEnabled: t.union([t.boolean, t.null]),
        autoReloadThreshold: t.union([t.number, t.null]),
        communicationPreferences: t.union([t.array(exports.TCommunicationPreference), t.null]),
        defaultAccountIdentifier: t.union([t.string, t.null]),
        defaultFdAccountId: t.union([t.string, t.null]),
        defaultPaymentAccountId: t.union([t.string, t.null]),
        defaultReloadAmt: t.union([t.number, t.null]),
        defaultScanAndPayAccountIdentifier: t.union([t.string, t.null]),
        deliveryAddresses: t.union([t.array(exports.TDeliveryAddress), t.null]),
        dob: t.union([t.string, t.null]),
        emailVerified: t.union([t.boolean, t.null]),
        favoriteStores: t.union([t.array(exports.TFavoriteStore), t.null]),
        gender: t.union([t.keyof(gender_1.Gender), t.null]),
        hasOrderedSuccessful: t.union([t.boolean, t.null]),
        isoCountryCode: t.union([t.keyof(country_code_1.IsoCountryCode), t.null]),
        lastAccountSyncTimestamp: t.union([t.number, t.null]),
        loyaltyTier: t.union([t.string, t.null]),
        name: t.union([t.string, t.null]),
        optedInLoyalty: t.union([t.boolean, t.null]),
        phoneNumber: t.union([t.string, t.null]),
        phoneVerified: t.union([t.boolean, t.null]),
        promotionalEmails: t.union([t.boolean, t.null]),
        registrationComplete: t.union([t.boolean, t.null]),
        rutrFailedSkillsTestTimestamp: t.union([t.string, t.null]),
        rutrPassedSkillsTestTimestamp: t.union([t.string, t.null]),
        showThLoyaltyOnboarding: t.boolean,
        zipcode: t.union([t.string, t.null]),
    }),
]);
exports.USER_LABEL = 'User';
exports.USER_NAMESPACE = exports.USER_LABEL;
//# sourceMappingURL=user.js.map